// router/index.js
import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/Home.vue';
import ProjectDetailView from '../views/ProjectDetailView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import BlogList from '../components/BlogList.vue';
// import BlogPost from '../components/BlogPost.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/projects/:id',
    name: 'ProjectDetailView',
    component: ProjectDetailView,
    props: true,
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicyView
  },
  {
    path: '/blog',
    name: 'BlogList',
    component: BlogList,
  },
  // {
  //   path: '/blog/:id',
  //   name: 'BlogPost',
  //   component: BlogPost,
  //   props: true,
  // },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth',
      };
    } else if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
